(function () {
  const preloader = document.getElementById("video-preloader");
  const video = document.getElementById("preloader-video");

  if (!preloader || !video) return;

  const MAX_TIME = 3000;

  function hide() {
    preloader.classList.add("hide");
    setTimeout(() => preloader.remove(), 700);
  }

  window.addEventListener("load", hide);
  setTimeout(hide, MAX_TIME);

  video.play().catch(() => {});
})();
